// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1I6Jn","errorLogs":"styles_errorLogs__iRACl"};